import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultAutoCompleteChipField } from 'src/components/mui-overrides/SelectTextField';
import { useAssetFeatureOptions } from 'src/hooks/useAssetFeatureOptions';
import { useAssetFeatures } from 'src/hooks/useAssetFeatures';

interface Props {
  disabled?: boolean;
}

export const AssetFeatureSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const assetFeatures = useAssetFeatures();
  const assetFeatureOptions = useAssetFeatureOptions(assetFeatures);

  return (
    <DefaultAutoCompleteChipField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.propertyoverview.fields.features.label')}
      fieldName="propertyDetails.features"
      options={assetFeatureOptions ?? []}
    />
  );
};
